// Centralized service configuration for delivery times and modification rounds
export const SERVICE_CONFIG = {
  // Delivery time in working days
  deliveryDaysText: 'maxim 10 zile lucrătoare',

  /** Maximum delivery days */
  deliveryDaysMax: 10,
  // Full text for modification rounds (handles singular/plural correctly)
  freeModificationRoundsText: '1 rundă de modificări gratuite',
} as const;
